/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CloseShadowTradeRequest } from '../models/CloseShadowTradeRequest';
import type { ShadowAnalyticsResponse } from '../models/ShadowAnalyticsResponse';
import type { ShadowBookResponse } from '../models/ShadowBookResponse';
import type { ShadowTradeResponse } from '../models/ShadowTradeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShadowBookService {
    /**
     * Get Shadow Book
     * Get all shadow trades.
     * @returns ShadowBookResponse Successful Response
     * @throws ApiError
     */
    public static getShadowBookApiV1ShadowBookGet({
        closedLimit = 50,
    }: {
        closedLimit?: number,
    }): CancelablePromise<ShadowBookResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shadow-book',
            query: {
                'closed_limit': closedLimit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Analytics
     * Get shadow trade analytics.
     * @returns ShadowAnalyticsResponse Successful Response
     * @throws ApiError
     */
    public static getAnalyticsApiV1ShadowBookAnalyticsGet(): CancelablePromise<ShadowAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shadow-book/analytics',
        });
    }
    /**
     * Get Snapshots
     * Get daily shadow P&L snapshots for the performance tab.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getSnapshotsApiV1ShadowBookSnapshotsGet({
        limit = 30,
    }: {
        limit?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shadow-book/snapshots',
            query: {
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Shadow Trades By Ticker
     * Get all shadow trades for a specific ticker (IDOR-safe).
     * @returns ShadowTradeResponse Successful Response
     * @throws ApiError
     */
    public static getShadowTradesByTickerApiV1ShadowBookTickerTickerGet({
        ticker,
    }: {
        ticker: string,
    }): CancelablePromise<Array<ShadowTradeResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shadow-book/ticker/{ticker}',
            path: {
                'ticker': ticker,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Shadow Trade
     * Get a single shadow trade by ID (IDOR-safe).
     * @returns ShadowTradeResponse Successful Response
     * @throws ApiError
     */
    public static getShadowTradeApiV1ShadowBookShadowIdGet({
        shadowId,
    }: {
        shadowId: number,
    }): CancelablePromise<ShadowTradeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shadow-book/{shadow_id}',
            path: {
                'shadow_id': shadowId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Close Shadow Trade
     * Manually close a shadow trade (IDOR-safe).
     * @returns ShadowTradeResponse Successful Response
     * @throws ApiError
     */
    public static closeShadowTradeApiV1ShadowBookShadowIdClosePost({
        shadowId,
        requestBody,
    }: {
        shadowId: number,
        requestBody: CloseShadowTradeRequest,
    }): CancelablePromise<ShadowTradeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/shadow-book/{shadow_id}/close',
            path: {
                'shadow_id': shadowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
